import React from 'react'
import ContactUsSection from '../../sections/ContactUs/ContactUsSection/ContactUsSection'

const ContactUsPage = () => {
  return (
    <div className='flex justify-center w-full'>
      <ContactUsSection />
    </div>
  )
}

export default ContactUsPage
